/** @jsx React.createElement */
/** @jsxFrag React.Fragment */
import * as React from 'react';
import clsx from 'clsx';
import {Button, Typography} from 'onboarding-components';
import {useState} from 'react';

import {Header} from 'common/onboarding/immersive-onboarding/components/header';
import {Content} from 'common/onboarding/immersive-onboarding/components/content';
import {IMMERSIVE_ASSETS} from 'common/onboarding/immersive-onboarding/assets/assets';
import {SetupGuideContext, Step} from 'common/onboarding/immersive-onboarding/types';

import styles from './explore.module.styl';

export const Explore = () => {
  const {isIntegrated, setOpen, setStep} = React.useContext(SetupGuideContext);

  const enum TemplateOptions {
    COMPANY_KPI = `Company KPIs`,
    FEATURE_LAUNCH_KPI = `Feature Launch KPIs`,
    LIFECYCLE_COHORT_ANALYSIS = `Lifecycle Cohort Analysis`,
  }
  const [selectedTemplate, setSelectedTemplate] = useState(TemplateOptions.COMPANY_KPI);

  const templateAssets = {
    [TemplateOptions.COMPANY_KPI]: IMMERSIVE_ASSETS.companyKpisTemplate,
    [TemplateOptions.FEATURE_LAUNCH_KPI]: IMMERSIVE_ASSETS.featureLaunchTemplate,
    [TemplateOptions.LIFECYCLE_COHORT_ANALYSIS]: IMMERSIVE_ASSETS.lifecycleCohortTemplate,
  };

  const handleReturnToSetup = () => {
    if (isIntegrated) {
      setOpen(false);
    } else {
      setStep(Step.Events);
    }
  };

  return (
    <>
      <Header title={`Explore product insights`} step={`step 3`} imgSrc={IMMERSIVE_ASSETS.goggles} duration={1} />
      <Content>
        <div className={styles.explore}>
          <div className={styles.header}>
            <div className={styles.heroImage}>
              <img
                src={isIntegrated ? IMMERSIVE_ASSETS.exploreCongratulations : IMMERSIVE_ASSETS.exploreNoEvents}
                width='250'
                height='208'
              />
            </div>
            <div className={styles.titleContainer}>
              <Typography className={styles.title} variant='headingMd' weight='bold'>
                {isIntegrated ? `Congratulations!` : `No events detected`}
              </Typography>

              <Typography className={styles.description} variant='bodySm' weight='regular'>
                {isIntegrated
                  ? `We received your data, and you’re ready to start learning. The templates below are a great place to start`
                  : `Activate the templates below by sending Mixpanel a couple events`}
              </Typography>
            </div>
            <div>
              <Button variant={isIntegrated ? `solid` : `transparent`} onClick={handleReturnToSetup}>
                {isIntegrated ? `Start Building` : `Return to Setup`}
              </Button>
            </div>
          </div>
          <div className={styles.useTemplate}>
            <Typography variant='bodySm'>{`To access even more templates, click`}</Typography>
            <Typography variant='bodySm' weight='bold'>
              {`+ New Board`}
            </Typography>
            <Typography variant='bodySm'>{`in the left side bar`}</Typography>
          </div>
          <div className={styles.useTemplateCta}>
            <div className={styles.ctaButtons}>
              <Button
                className={clsx(styles.ctaButton, {
                  [styles.ctaButtonSelected]: selectedTemplate === TemplateOptions.COMPANY_KPI,
                })}
                variant='transparent'
                onClick={() => {
                  setSelectedTemplate(TemplateOptions.COMPANY_KPI);
                }}
              >
                {TemplateOptions.COMPANY_KPI}
              </Button>
              <Button
                className={clsx(styles.ctaButton, {
                  [styles.ctaButtonSelected]: selectedTemplate === TemplateOptions.FEATURE_LAUNCH_KPI,
                })}
                variant='transparent'
                onClick={() => {
                  setSelectedTemplate(TemplateOptions.FEATURE_LAUNCH_KPI);
                }}
              >
                {TemplateOptions.FEATURE_LAUNCH_KPI}
              </Button>
              <Button
                className={clsx(styles.ctaButton, {
                  [styles.ctaButtonSelected]: selectedTemplate === TemplateOptions.LIFECYCLE_COHORT_ANALYSIS,
                })}
                variant='transparent'
                onClick={() => {
                  setSelectedTemplate(TemplateOptions.LIFECYCLE_COHORT_ANALYSIS);
                }}
              >
                {TemplateOptions.LIFECYCLE_COHORT_ANALYSIS}
              </Button>
            </div>
            <div className={styles.ctaImage}>
              <img src={templateAssets[selectedTemplate]} width='969' height='448' />
            </div>
          </div>
          <div className={styles.exploreFooterButton}>
            <Button
              onClick={() => {
                setOpen(false);
              }}
            >
              {`Finish and close`}
            </Button>
          </div>
        </div>
      </Content>
    </>
  );
};
